import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import './assets/css/global.css'
import { getSeoConfig } from './api/seo'
import { applyGlobalSeo, setDocumentTitleWithSite } from './utils/seo'

Vue.config.productionTip = false
Vue.use(ElementUI)

axios.defaults.baseURL = '/'
Vue.prototype.$http = axios

let __globalSeo = null

// Fetch global SEO once on app bootstrap
getSeoConfig().then(res => {
  const data = res && res.data
  let seo = null
  if (data) {
    // compatible with axios direct .data or our request util shape
    const rows = data.rows || (data.data && data.data.rows)
    if (Array.isArray(rows) && rows.length > 0) {
      seo = rows[0]
    }
  }
  if (seo) {
    __globalSeo = seo
    window.__GLOBAL_SEO__ = seo
    applyGlobalSeo({
      siteName: seo.siteName,
      keywords: seo.keywords,
      description: seo.description,
      siteLogo: seo.siteLogo,
      footerInfo: seo.footerInfo
    })
    try { window.dispatchEvent(new CustomEvent('seo-updated', { detail: seo })) } catch (e) {}
  }
}).catch(() => {})

router.beforeEach((to, from, next) => {
  const isProjectDetail = to.name === 'ProjectDetail'
  const pageTitle = to.meta && to.meta.title
  const siteName = (__globalSeo && __globalSeo.siteName) || '海南鼎昂建筑工程有限公司'

  if (isProjectDetail) {
    // Do not override per-project detail SEO; leave as-is
    // If entering detail without project SEO applied yet, keep current title
    // No global meta apply here
  } else {
    setDocumentTitleWithSite(pageTitle, siteName)
    if (__globalSeo) {
      window.__GLOBAL_SEO__ = __globalSeo
      applyGlobalSeo({
        siteName: siteName,
        keywords: __globalSeo.keywords,
        description: __globalSeo.description,
        siteLogo: __globalSeo.siteLogo
      })
      try { window.dispatchEvent(new CustomEvent('seo-updated', { detail: __globalSeo })) } catch (e) {}
    }
  }
  next()
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')